import { useContext, useState } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Button from "../../../components/Button";
import { POST } from "../../../api/requests";
import SettingsField from "../SettingsField";
import { useDialog } from "../../../contexts/DialogContext";

export default function NewOrganization({}) {
  // Load user profile settings into the state
  // Get these from supabase directly supabase.auth.getUser()
  // Do a deep compare to see if anything is different

  const { session, supabase } = useContext(AuthContext);
  const { hideDialog } = useDialog();
  const [orgName, setOrgName] = useState(null);
  const [orgConfig, setOrgConfig] = useState({});
  const createOrganization = async () => {
    // TODO
    if (orgName && orgName.length > 1) {
      const response = await POST(`/organizations`, { name: orgName });
    } else {
      console.error("Organization name must be longer than one character.");
    }
  };

  return (
    <div className="relative" style={{ height: "100%" }}>
      <h1 className="text-lg font-bold text-gray-800 mb-3">
        Create a new team
      </h1>

      <div className="space-y-4">
        <SettingsField
          label="Team name"
          onChange={(e) => setOrgConfig({ ...orgConfig, name: e.target.value })}
        />
        <div className="flex space-x-2 items-center">
          <button
            onClick={hideDialog}
            className="border shadow-sm bg-white text-gray-700 rounded-lg px-3 py-2 text-sm font-medium"
          >
            Cancel
          </button>

          <Button label="Create team" onClick={createOrganization} />
        </div>
      </div>
    </div>
  );
}
